import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { authToken } from "../../../service/adminService";
import { requestCanceller } from "../../../service/axiosCancelToken";
import { decodeToken } from "../../../service/decodeToken";

function ProtectedRoute({ component: Component, ...restOfProps }) {

const history = useHistory();
const [authenticated, setAuthenticated] = useState(false);

useEffect(() => {

    const cancelRequest = requestCanceller();

    const authorization = async () => {
        try {
            let token;
            if (!localStorage.getItem('token'))
            history.replace('/login');
            else
            token = localStorage.getItem('token');

            let isExpired = false;
            let decodedToken = decodeToken(token);
            let dateNow = Date.now()/1000;

            if(decodedToken.payload.exp < dateNow)
            {
            localStorage.removeItem('token');
            isExpired = true;
            }
            if(isExpired)
            history.replace('/login');

            const { status } = await authToken({cancelToken: cancelRequest.signal});
            if(status === 201){
                setAuthenticated(true);
            }

        } catch (err) {
            if(err.response && err.response.status === 401){
                localStorage.removeItem('token');
                history.replace('/login')
            }
        }
        
    }
    authorization();
    return () => {
        cancelRequest.cancel();
    }
    
},[history])

  return (
    <Route {...restOfProps}
        render={(props) => authenticated && <Component {...props} />
    }
    />
  );
}

export default ProtectedRoute;